import Vue from 'vue';

Vue.component('custom-form', require('./form').default);
Vue.component('custom-input', require('./input').default);
Vue.component('custom-button', require('./button').default);

